export default {"src":"/_next/static/media/TNT_Logo.ecde2935.svg","height":519,"width":1134};